<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Mudança de Horário</h5>
                <hr>
                <TabView>					
      				<TabPanel header="Cadastro" class="p-mt-3">
						<NovaMudancaHorario/>						
      				</TabPanel>
                    <TabPanel header="Lista" class="p-mt-3">
						<ListaMudancasHorarios/>
      				</TabPanel>
                </TabView>
			</div>
		</div>
    </div>
</template>

<script>
import NovaMudancaHorario from '@/components/pages/movimento/mudancaHorario/NovaMudancaHorario.vue';
import ListaMudancasHorarios from '@/components/pages/movimento/mudancaHorario/ListaMudancasHorarios.vue';

export default {	
	components: {
		'NovaMudancaHorario': NovaMudancaHorario,
		'ListaMudancasHorarios': ListaMudancasHorarios,
    }
}
</script>

<style>

</style>